import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54942daa"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "croper"
};
const _hoisted_3 = {
  class: "wrapper"
};
const _hoisted_4 = /*#__PURE__*/_createTextVNode("上传中...");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_vueCropper = _resolveComponent("vueCropper");
  const _component_van_popup = _resolveComponent("van-popup");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_popup, {
    class: "bg-tran image-cropper",
    show: $options.show,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $options.show = $event),
    "close-icon-position": "top-left",
    position: "bottom",
    style: {
      height: '100%'
    },
    "lock-scroll": false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
      class: "left-icon",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/idea_image_crop_close_icon.png', 48),
      onClick: $options.onCancel
    }, null, 8, ["src", "onClick"]), _createVNode(_component_van_image, {
      class: "right-icon",
      src: _ctx.$imgUrlFilter('https://p6.moimg.net/mdwxapp/idea_image_crop_finish_icon.png', 52),
      onClick: $options.onConfirm
    }, null, 8, ["src", "onClick"])]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_vueCropper, {
      class: "my-cropper-box",
      ref: "imageCropper",
      img: $props.url,
      outputSize: $data.option.outputSize,
      outputType: $data.option.outputType,
      info: $data.option.info,
      full: $data.option.full,
      autoCropWidth: $data.option.autoCropWidth,
      autoCropHeight: $data.option.autoCropHeight,
      canMove: $data.option.canMove,
      canMoveBox: $data.option.canMoveBox,
      original: $data.option.original,
      autoCrop: $data.option.autoCrop,
      fixed: $data.option.fixed,
      fixedNumber: $data.option.fixedNumber,
      centerBox: $data.option.centerBox,
      infoTrue: $data.option.infoTrue,
      fixedBox: $data.option.fixedBox,
      high: $data.option.high,
      mode: $data.option.mode
    }, null, 8, ["img", "outputSize", "outputType", "info", "full", "autoCropWidth", "autoCropHeight", "canMove", "canMoveBox", "original", "autoCrop", "fixed", "fixedNumber", "centerBox", "infoTrue", "fixedBox", "high", "mode"])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    show: $data.loading
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_loading, {
      size: "24px",
      color: "#fff",
      vertical: ""
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    })])]),
    _: 1
  }, 8, ["show"])], 64);
}